var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17747_99309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.99914V10.9991H5.5V19.9991H19.5V10.9991H16.5V8.99914H19.5C20.6046 8.99914 21.5 9.89457 21.5 10.9991V19.9991C21.5 21.1037 20.6046 21.9991 19.5 21.9991H5.5C4.39543 21.9991 3.5 21.1037 3.5 19.9991V10.9991C3.5 9.89456 4.39543 8.99914 5.5 8.99914H8.5ZM13.3839 2.46768L16.7426 5.82644C17.1332 6.21697 17.1332 6.85012 16.7426 7.24064C16.3521 7.63118 15.719 7.63118 15.3284 7.24064L13.5 5.41223V14.9991C13.5 15.5514 13.0523 15.9991 12.5 15.9991C11.9477 15.9991 11.5 15.5514 11.5 14.9991V5.41223L9.67157 7.24064C9.28105 7.63118 8.64788 7.63118 8.25736 7.24064C7.86684 6.85012 7.86684 6.21697 8.25736 5.82644L11.6161 2.46768C12.1043 1.97952 12.8957 1.97952 13.3839 2.46768Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17747_99309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.613266f5851074e7e906231d563218b2.svg";
export { ForwardRef as ReactComponent };